module.exports = __webpack_public_path__ + "img/transportVoucher.2d355eef.png";